import React, { useRef, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import logo from '../../assets/logo/pal-logo.png';
import './Form.scss';

const Signup = () => {

    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const { signup } = useAuth();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmit = async(e) => {
        e.preventDefault();

        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError('Passwords do not match');
        }
        try {
            setError('');
            setLoading(true);
            await signup(emailRef.current.value, passwordRef.current.value);
            history.push("/");
        } catch {
            setError('Failed to create an account')
        }

        setLoading(false);
    }

    return (
        <div className="form">
            <h2 className="form__title"><img className="form__logo" src={logo} alt="palette. logo"/>Sign Up</h2>
                {error && <h2>{error}</h2>}
            <form className="form__container" onSubmit={handleSubmit}>
                <div className="form__wrapper">
                    <label htmlFor="email" className="form__label">Email</label>
                    <input type="email" className="form__input" ref={emailRef}/>
                </div>
                <div className="form__wrapper">
                    <label htmlFor="password" className="form__label">Password</label>
                    <input type="password" className="form__input" ref={passwordRef}/>
                </div>
                <div className="form__wrapper">
                    <label htmlFor="passwordConfirm" className="form__label">Confirm Password</label>
                    <input type="password" className="form__input" ref={passwordConfirmRef}/>
                </div>
                <button disabled={loading} type="submit" className="form__btn">Sign Up</button>
            </form>
            <div className="form__alt">Already have an account? <Link className="form__link" to="/login">Log in</Link></div>
        </div>
    )
}

export default Signup;

